import React from 'react';
import { useLanguage } from '../contexts/LanguageContext';
import { Calendar, ArrowRight } from 'lucide-react';

const FinalCTA = () => {
  const { t } = useLanguage();
  
  return (
    <section className="final-cta-section">
      <div className="section-container">
        <div className="final-cta-content">
          <div className="cta-icon-badge">
            <Calendar size={32} />
          </div>
          
          <h2 className="final-cta-title">{t('finalCtaTitle')}</h2>
          <p className="final-cta-subtitle">{t('finalCtaSubtitle')}</p>
          
          <a 
            href="https://calendly.com/partsnap-info/15min" 
            target="_blank" 
            rel="noopener noreferrer"
            className="cta-button final-cta-button"
          >
            <span>{t('bookMeeting')}</span>
            <ArrowRight className="button-icon" size={20} />
          </a>
        </div>
      </div>
    </section>
  );
};

export default FinalCTA;
